'use client';

import {isBrowser} from '@/lib/utils/page.utils';
import {useSnackbar, SnackbarProps} from '@eds-web/react';
import {useMessages} from '@epic-mw/i18n';
import {useEffect} from 'react';

type SnackbarDetail = {message: string; type?: 'critical' | 'neutral' | 'warning' | 'success'};
type SnackbarEvent = CustomEvent<SnackbarDetail>;

const EVENT_NAME = 'snackbar';

/**
 *
 * @param detail object - type d
 */
export const dispatchSnackbar = (message: string, type: SnackbarDetail['type'] = 'neutral') => {
	dispatchEvent(
		new CustomEvent(EVENT_NAME, {
			bubbles: false,
			detail: {
				message,
				type
			}
		})
	);
};

export const useSnackbarListener = () => {
	const snackbar = useSnackbar();
	const messages = useMessages();

	useEffect(() => {
		if (!isBrowser()) {
			return;
		}
		const handleSnackbar = (event) => {
			const detail = (event as SnackbarEvent)?.detail || {};
			const {message, type} = detail;

			const props: SnackbarProps = {
				message: messages[message] || message,
				closeLabel: messages['epic.app.close']
			};

			(snackbar[type as keyof typeof snackbar] ?? snackbar.neutral)(props);
		};

		window.addEventListener(EVENT_NAME, handleSnackbar);

		return () => {
			window.removeEventListener(EVENT_NAME, handleSnackbar);
		};
	}, []);
};
